import Pusher from 'pusher-js';

export const createPusherInstance = () => {
	// Initialize Pusher
	const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
		cluster: 'us3',
	});
	window.pusher = pusher;
};
